/* Ported from src/pages/CataloguePage.tsx — client-side category pill filter, zero network round-trip. */
(function () {
  function init(root) {
    var buttons = root.querySelectorAll('[data-catalogue-filter]');
    var cards = root.querySelectorAll('[data-category]');
    var emptyMessage = root.querySelector('[data-catalogue-empty]');

    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        var filter = button.getAttribute('data-catalogue-filter');

        buttons.forEach(function (b) {
          b.classList.toggle('is-active', b === button);
        });

        var visibleCount = 0;
        cards.forEach(function (card) {
          var match = filter === 'Tout' || card.getAttribute('data-category') === filter;
          card.hidden = !match;
          if (match) visibleCount++;
        });

        if (emptyMessage) emptyMessage.hidden = visibleCount !== 0;
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-oblivion-catalogue]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
